import styled from 'styled-components';
import { rgba } from 'polished';

import * as Colors from '../../attrs/colors';
import * as Shadows from '../../attrs/shadows';
import MQ from '../../attrs/mq';

export const Container = styled.div`
  position: fixed;
  z-index: 2000;
  bottom: 1rem;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  justify-content: center;

  a {
    color: ${Colors.BLACK};
    border-bottom: 1px solid ${rgba(Colors.BLACK, 0.25)};

    :hover {
      border-bottom-color: ${rgba(Colors.BLACK, 0.5)};
    }
  }

  ${MQ.md`
    bottom: 2rem;
  `}
`;

export const Items = styled.div`
  background: ${Colors.WHITE};
  box-shadow: ${Shadows.SHADOW_EQ_40};
  display: flex;
  padding: 0.5rem 1rem;
  border-radius: 2px;
  flex-direction: column;
  text-align: center;
  font-size: 0.9rem;

  ${MQ.md`
    font-size: 1rem;
    flex-direction: row;
  `}
`;

export const Item = styled.div`
  margin-bottom: 0.5rem;

  ${MQ.md`
    margin-bottom: 0;
    margin-right: 1rem;

    :last-child {
      margin-right: 0;
    }
  `}
`;

export const Link = styled.a``;
